import { IListResponse, useXHR, XHRInstance } from "@sembark-travel/xhr"
import { IUser } from "../Users"
import useSWR from "swr"

export type TLeadChannel = {
	id: number
	name: string
	is_auto: 0 | 1
	lead_channel_category?: string
	created_by?: IUser
	created_at: string
	updated_at?: string
	updated_by?: IUser
	deleted_at?: string
}

export function useLeadCategoryOptions() {
	const xhr = useXHR()

	const { data, isLoading } = useSWR("/lead-categories", () =>
		LeadChannelXHR(xhr).categories()
	)

	const options = data?.map((category) => ({
		id: category,
		name: category,
	}))

	return { options, isLoading }
}
export function LeadChannelXHR(xhr: XHRInstance) {
	return {
		async get(params?: unknown) {
			return xhr
				.get<IListResponse<TLeadChannel>>("/lead-channels", { params })
				.then((resp) => resp.data)
		},

		async categories(params?: unknown) {
			return xhr
				.get<string[]>("/lead-channel/categories", { params })
				.then((resp) => resp.data)
		},

		async create(data: unknown) {
			return xhr.post("/lead-channels", data).then((resp) => resp.data)
		},

		async update(id: number, data: unknown) {
			return xhr.post(`/lead-channels/${id}`, data).then((resp) => resp.data)
		},

		async destroy(id: number) {
			return xhr.delete(`/lead-channels/${id}`).then((resp) => resp.data)
		},
		async restore(id: number) {
			return xhr.patch(`/lead-channels/${id}/restore`).then((resp) => resp.data)
		},
	}
}
